import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import classnames from 'classnames'

import config from 'config'
import { valueToString } from 'services/string'
import { image, utils } from 'services'

import { Button } from 'controls'
import { PictureThumbnail } from 'components/Picture'

import styles from './styles'

const NCC_PHONE = config('NCC_PHONE')

class BrokerCard extends Component {
  static propTypes = {
    brokerData: PropTypes.object.isRequired,
    handleRequestPhone: PropTypes.func
  }

  static defaultProps = {
    handleRequestPhone: () => {}
  }

  constructor(props) {
    super(props)
    this.state = { showTelephone: false }
  }

  render() {
    const { handleRequestPhone } = this.props

    const {
      id,
      firstName,
      lastName,
      secondLastName = '',
      rating = 5,
      avatar = image('/icons/vip/photo.png'),
      telephone,
      role = 'Agente'
    } = this.props.brokerData

    const fullName = `${valueToString(firstName)} ${valueToString(
      lastName
    )} ${valueToString(secondLastName)}`
    const { showTelephone } = this.state
    const { className, hideBroker } = this.props
    const slugUrl = utils.slugify(fullName)

    return (
      <section className={classnames('card', className)}>
        {!hideBroker && (
          <div className="info">
            <div className="avatar">
              <Link
                href={{
                  pathname: '/teamProfile',
                  query: { slug: slugUrl, id }
                }}
                as={`/equipo/${slugUrl}/${id}`}
              >
                <a className="name" title={fullName}>
                  {avatar ? (
                    <PictureThumbnail
                      image={avatar}
                      size='avatar'
                      format="webp"
                      alt={fullName}
                      className="broker-card-image"
                    />
                  ) : (
                    <img
                      src={image('advantage/no-foto-solido.png')}
                      alt="Sin foto"
                      width={72}
                      height={72}
                    />
                  )}
                </a>
              </Link>
            </div>

            <div className="details">
              <Link
                href={{
                  pathname: '/teamProfile',
                  query: { slug: slugUrl, id }
                }}
                as={`/equipo/${slugUrl}/${id}`}
              >
                <a className="name" title={fullName}>
                  {fullName}
                </a>
              </Link>
              <p className="role">{role}</p>
            </div>
          </div>
        )}
        <Button
          outline={!showTelephone}
          color="primary"
          onClick={() => {
            this.setState({ showTelephone: true })
            handleRequestPhone()
          }}
        >
          {showTelephone ? NCC_PHONE : 'Ver teléfono'}
        </Button>
        <style jsx>{styles}</style>
      </section>
    )
  }
}

export default BrokerCard
